module.exports = __webpack_public_path__ + "media/images/apple-icon-114x114-69b9cece34a69d8a2ba84500f1c8858f.png";